var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import moment from 'moment';
import CurrencyFormatter from '../../../core/utils/currency-formatter';
import CtaButton from '../../../components/CtaButton';
import CartItemImage from '../../../components/CartItemImage';
import { localizeUrl } from '../../../core/helpers/url-helper';
import { createClassListFromModifiers } from '../../../core/utils/class-helper';
import { deleteCartItem, fetchDraftItems } from '../../Cart/store/actions';
import { hideConfirm, showConfirm } from '../../Confirm/store/actions';
var mapDispatchToProps = {
    deleteCartItem: deleteCartItem,
    fetchDraftItems: fetchDraftItems,
    showConfirm: showConfirm,
    hideConfirm: hideConfirm,
};
var connector = connect(null, mapDispatchToProps);
var DraftListItem = /** @class */ (function (_super) {
    __extends(DraftListItem, _super);
    function DraftListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DraftListItem.prototype.render = function () {
        var _this = this;
        var classList = __spreadArray([
            'c-draft-item'
        ], createClassListFromModifiers('c-draft-item', this.props.modifier));
        var lastUpdatedPhoto = __spreadArray([], this.props.item.photos).sort(function (a, b) { return a.updated_at > b.updated_at ? -1 : 1; }).shift();
        var lastUpdatedDays = lastUpdatedPhoto ? moment().diff(moment(lastUpdatedPhoto.updated_at), 'days') : null;
        return (React.createElement("div", { className: classList.join(' ') },
            React.createElement("div", { className: "c-draft-item__left" },
                React.createElement("div", { className: "c-draft-item__left__image" },
                    React.createElement(CartItemImage, { item: this.props.item })),
                React.createElement("div", { className: "c-draft-item__left__content" },
                    React.createElement("div", { className: "c-draft-item__left__content__name" },
                        React.createElement("h2", null, this.props.item.getName()),
                        null !== lastUpdatedDays && (React.createElement("span", null, this.props.t(lastUpdatedDays > 0 ? 'drafts.list.last_updated_other' : 'drafts.list.last_updated_today', { days: lastUpdatedDays })))),
                    React.createElement("div", { className: "c-draft-item__left__content__price" },
                        React.createElement("span", null, CurrencyFormatter.format(this.props.item.getTotal()))))),
            React.createElement("div", { className: "c-draft-item__buttons" },
                React.createElement(CtaButton, { label: "button.continue", link: localizeUrl("/cart-items/" + this.props.item.id), modifier: ['pink-100'] }),
                React.createElement("div", { className: "h-padding-left--30" },
                    React.createElement(CtaButton, { icon: "remove", modifier: ['pink-100', 'rounded'], clickHandler: function () {
                            _this.props.showConfirm({
                                title: 'confirm.draft_remove.title',
                                message: 'confirm.draft_remove.message',
                                handleConfirm: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.props.deleteCartItem(this.props.item.id)];
                                            case 1:
                                                response = _a.sent();
                                                if (!response) {
                                                    return [2 /*return*/];
                                                }
                                                return [4 /*yield*/, this.props.fetchDraftItems()];
                                            case 2:
                                                _a.sent();
                                                this.props.hideConfirm();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                            });
                        } })))));
    };
    return DraftListItem;
}(React.Component));
export default connector(withTranslation()(DraftListItem));
